import './skeleton-class-branches.scss';
import Skeleton from '@mui/material/Skeleton';
import Grid from '@mui/material/Grid';

export const SkeletonClassBranches = () => {

    return (
        <div className='skeleton-class-branch'>
            <Grid container spacing={1} className="swiper">
                <Grid item xs={2}>
                    <Skeleton variant="rectangular" height={60} />
                </Grid>
                <Grid item xs={2}>
                    <Skeleton variant="rectangular" height={60} />
                </Grid>
                <Grid item xs={2}>
                    <Skeleton variant="rectangular" height={60} />
                </Grid>
                <Grid item xs={2}>
                    <Skeleton variant="rectangular" height={60} />
                </Grid>
                <Grid item xs={2}>
                    <Skeleton variant="rectangular" height={60} />
                </Grid>
                <Grid item xs={2}>
                    <Skeleton variant="rectangular" height={60} />
                </Grid>
            </Grid>
            <Grid container spacing={1} className="swiper">
                <Grid item xs={3}>
                    <Skeleton variant="rectangular" height={180} />
                </Grid>
                <Grid item xs={3}>
                    <Skeleton variant="rectangular" height={180} />
                </Grid>
                <Grid item xs={3}>
                    <Skeleton variant="rectangular" height={180} />
                </Grid>
                <Grid item xs={3}>
                    <Skeleton variant="rectangular" height={180} />
                </Grid>
            </Grid>
            <Grid container spacing={1} className="swiper">
                <Grid item xs={3}>
                    <Skeleton variant="rectangular" height={180} />
                </Grid>
                <Grid item xs={3}>
                    <Skeleton variant="rectangular" height={180} />
                </Grid>
                <Grid item xs={3}>
                    <Skeleton variant="rectangular" height={180} />
                </Grid>
                <Grid item xs={3}>
                    <Skeleton variant="rectangular" height={180} />
                </Grid>
            </Grid>
            <Grid container spacing={1} className="swiper">
                <Grid item xs={3}>
                    <Skeleton variant="rectangular" height={180} />
                </Grid>
                <Grid item xs={3}>
                    <Skeleton variant="rectangular" height={180} />
                </Grid>
                <Grid item xs={3}>
                    <Skeleton variant="rectangular" height={180} />
                </Grid>
                <Grid item xs={3}>
                    <Skeleton variant="rectangular" height={180} />
                </Grid>
            </Grid>
        </div >
    );
}